import moment, { Moment } from 'moment';
import { DateRange as MomentDateRange } from 'moment-range';

/**
 * Properly typed DateRange interface that extends the moment-range DateRange
 * with properly typed start and end properties (which are typed as `any` in the original)
 */
export interface TypedDateRange extends Omit<MomentDateRange, 'start' | 'end'> {
  start: Moment;
  end: Moment;
}

/**
 * Type guard/assertion to convert a MomentDateRange to a TypedDateRange
 * This is safe because DateRange's start and end are always Moment objects at runtime
 */
export function getTypedDateRange(range: MomentDateRange): TypedDateRange {
  return range as unknown as TypedDateRange;
}

/**
 * Get the start date from a DateRange with proper typing
 * Wraps the value in moment() to ensure proper Moment type
 */
export function getRangeStart(range: MomentDateRange): Moment {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return moment(range.start);
}

/**
 * Get the end date from a DateRange with proper typing
 * Wraps the value in moment() to ensure proper Moment type
 */
export function getRangeEnd(range: MomentDateRange): Moment {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return moment(range.end);
}
